import { authApi } from './authService';
// import { authApiB } from './authApiB';

const authApis = [authApi.middleware];
export default authApis;